export default "__VITE_ASSET__DggsFyb$__"